// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { UltraHDRLoader } from "three/examples/jsm/Addons.js";
import TWEEN from "@tweenjs/tween.js";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TransformControls } from "three/examples/jsm/controls/TransformControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
import { Gizmo } from "./gizmo";
import { Popup } from "./popup";
// import { useNavigate } from "react-router-dom";
import { addMenuBtn, addDiv, addInput, addImage, addLabel, addHorizLine, addColorPicker, addButton, addCheckbox } from "./dom";
import { smoothScrollToParent } from "./utils";
import { Switch } from "./switch";
import { SlidingNumericStepper } from "./sns";
import { RangeSlider } from "./rangeslider";
import { ListMini } from "./listmini";
import { MVPreloader } from "./MVPreloader";
import "./ThreeJS.css";
import { Gallery } from "./gallery";
import { getAsset } from "../getAsset";

// export default function ThreeJS({ user, project }) {
export default function ThreeJS() {
  let [loaded, setLoaded] = useState(0);
  let [showPreloader, setShowPreloader] = useState(false);

  let activePage = useRef(null);
  let userPage = useRef(null);
  let filePage = useRef(null);
  let viewportPage = useRef(null);
  let listPage = useRef(null);
  let assemblyPage = useRef(null);
  let meshPage = useRef(null);
  // let listRef = useRef(null);

  let app = useRef(null);
  let menu = useRef(null);
  let msg = useRef(null);
  let canvas = useRef(null);
  let gizmoDiv = useRef(null);
  let toolsDiv = useRef(null);
  let animateRef = useRef(null);
  let panelLeft = useRef(null);
  let panelRight = useRef(null);
  //   let navigate = useNavigate();
  let isFullscreen = useRef(false);
  let meshName = useRef(false);

  useEffect(() => {
    let exploded = false;
    let explodeParam_m;
    let x_m, y_m, z_m, rx_m, ry_m, rz_m;
    let x_a, y_a, z_a, rx_a, ry_a, rz_a;
    let selectedType = "assembly";
    let transformOn = false;
    let pressTimer = null;
    let menuAssembly, menuMesh;
    let orientation = window.screen.width < window.screen.height ? "portrait" : "landscape";
    let scene, camera, renderer, transform, controls, view, assemblyRoot, assembly, hidden, raycaster, mouse;
    let popup, header, gizmo, logo, fullscreen, tag, param, paramLock, totalItems, itemCount, list, toggleView, unlock;
    let switchParamExplode, switchExplode, colorPicker, colorInput;
    let paramAssembly;
    let helpBox, helpSheet;
    let plane;
    let searchBox;
    let arrayBuffer = null;
    let items = [];
    let filteredList = [];
    let meshMatrixBox = null;
    let meshMatrixBar = null;
    let meshMatrixHeight = 310;
    let activeItem = null;
    let activeListItem = null;
    let deg2Rad = Math.PI / 180;
    let rad2Deg = 180 / Math.PI;
    let spinangle = 0;
    let selectedColor = 0x2ab12a;
    let focusColor = 0xffae00;
    let eIntensity = 0.25;
    let tweenDuration = 1000;
    let allvisible = true;
    let allLock = false;
    let activeNameInput = null;
    let INTERSECTED = null;
    let copiedMat = null;
    let spin = false;
    let reset;
    let loader;
    let hdri;
    let delMeshName;
    let lightIntensity = 1;
    let distance = 100;
    let ambient = new THREE.AmbientLight(0xffffff, 1.5);
    let lightTop = new THREE.DirectionalLight(0xffffff, lightIntensity);
    let extension;
    let viewport;
    let exporter = new GLTFExporter();
    let meshes = [];
    let showMeshName = true;

    let listMini, miniInput;

    mouse = new THREE.Vector2();
    raycaster = new THREE.Raycaster();
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 4000);
    camera.position.set(6, 6, 6);
    camera.fov = 60;

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.shadowMap.enabled = true;
    THREE.ColorManagement.enabled = true;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    transform = new TransformControls(camera, renderer.domElement);
    transform.addEventListener("dragging-changed", function (e) {
      controls.enabled = !e.value;
    });
    transform.addEventListener("objectChange", () => {
      let pos = transform.object.position;
      let rot = transform.object.rotation;
      let x = Math.ceil((pos.x * 10) / 10);
      let y = Math.ceil((pos.y * 10) / 10);
      let z = Math.ceil((pos.z * 10) / 10);

      if (activeItem) {
        snsX.value = x;
        snsY.value = y;
        snsZ.value = z;

        x_m.setValue(x);
        y_m.setValue(y);
        z_m.setValue(z);

        let degx = (rot.x * rad2Deg) % 360;
        if (degx < 0) degx += 360;
        let degy = (rot.y * rad2Deg) % 360;
        if (degy < 0) degy += 360;
        let degz = (rot.z * rad2Deg) % 360;
        if (degz < 0) degz += 360;

        snsRX.value = degx;
        snsRY.value = degy;
        snsRZ.value = degz;

        rx_m.setValue(Math.ceil(degx));
        ry_m.setValue(Math.ceil(degy));
        rz_m.setValue(Math.ceil(degz));

        if (activeItem.userData.explode) {
          activeItem.userData.x2 = x;
          activeItem.userData.y2 = y;
          activeItem.userData.z2 = z;
        } else {
          activeItem.userData.x1 = x;
          activeItem.userData.y1 = y;
          activeItem.userData.z1 = z;
        }
      } else {
        snsAX.value = assembly.position.x = x;
        snsAY.value = assembly.position.y = y;
        snsAZ.value = assembly.position.z = z;

        x_a.setValue(x);
        y_a.setValue(y);
        z_a.setValue(z);

        let degx = (rot.x * rad2Deg) % 360;
        if (degx < 0) degx += 360;
        let degy = (rot.y * rad2Deg) % 360;
        if (degy < 0) degy += 360;
        let degz = (rot.z * rad2Deg) % 360;
        if (degz < 0) degz += 360;
        snsARX.value = degx;
        snsARY.value = degy;
        snsARZ.value = degz;

        rx_a.setValue(Math.ceil(degx));
        ry_a.setValue(Math.ceil(degy));
        rz_a.setValue(Math.ceil(degz));
      }
    });
    // scene.add(transform);
    transform.setMode("translate");

    loadHDRI("sunrise.jpg");

    header = addDiv(app.current, "header", "header");
    logo = addImage(header, "logo", "logo.svg", "logo");
    fullscreen = addImage(header, "fullscreen", "fullscreen.svg", "fullscreen");

    if (canvas.current) {
      renderer.domElement.id = "canvas";
      renderer.domElement.classList.add("canvas");
      canvas.current.appendChild(renderer.domElement);
      canvas.current.appendChild(header);
    }
    if (menu.current) {
      addMenuBtn(menu.current, "menuUser", "user.svg");
      addMenuBtn(menu.current, "menuFile", "file.svg");
      addMenuBtn(menu.current, "menuViewport", "viewport.svg");
      addMenuBtn(menu.current, "menuSearch", "searchList.svg");
      menuAssembly = addMenuBtn(menu.current, "menuAssembly", "assembly.svg", false);
      menuMesh = addMenuBtn(menu.current, "menuMesh", "mesh.svg", false);
    }
    viewport = renderer.domElement;

    lightTop.castShadow = true;
    lightTop.shadow.mapSize.width = 2048; // higher resolution improves softness quality
    lightTop.shadow.mapSize.height = 2048;
    lightTop.shadow.radius = 4;
    lightTop.position.set(0, distance, 0);

    var lightBottom = new THREE.DirectionalLight(0xffffff, lightIntensity);
    lightBottom.castShadow = true;
    lightBottom.position.set(0, -distance, 0);

    var lightRight = new THREE.DirectionalLight(0xffffff, lightIntensity);
    lightRight.castShadow = true;

    lightRight.shadow.mapSize.width = 2048;
    lightRight.shadow.mapSize.height = 2048;
    lightRight.shadow.radius = 4;
    lightRight.position.set(distance, 0, 0);

    var lightLeft = new THREE.DirectionalLight(0xffffff, lightIntensity);
    lightLeft.castShadow = true;
    lightLeft.shadow.mapSize.width = 2048;
    lightLeft.shadow.mapSize.height = 2048;
    lightLeft.shadow.radius = 4;
    lightLeft.position.set(-distance, 0, 0);

    var lightFront = new THREE.DirectionalLight(0xffffff, lightIntensity);
    lightFront.castShadow = true;
    lightFront.position.set(0, 0, distance);

    var lightBack = new THREE.DirectionalLight(0xffffff, lightIntensity);
    lightBack.castShadow = true;
    lightBack.position.set(0, 0, -distance);

    controls = new OrbitControls(camera, renderer.domElement);
    controls.minAzimuthAngle = -Infinity;
    controls.maxAzimuthAngle = Infinity;

    controls.enablePan = true;
    controls.panSpeed = 1;

    reset = {
      position: camera.position.clone(),
      target: controls.target.clone(),
    };

    view = new THREE.Group();
    assemblyRoot = new THREE.Group();
    // let s = 0.03;
    let s = 0.04;
    assemblyRoot.scale.set(s, s, s);
    assembly = new THREE.Group();
    assembly.add(assemblyRoot);

    hidden = new THREE.Group();
    hidden.scale.set(0, 0, 0);

    view.add(assembly);
    view.add(hidden);

    view.add(ambient);
    view.add(lightTop);
    view.add(lightBottom);
    view.add(lightRight);
    view.add(lightLeft);
    view.add(lightFront);
    view.add(lightBack);

    scene.add(view);
    addBase();

    popup = new Popup();

    let searchArea = addDiv(panelRight.current, "searchArea", "searchArea");

    let searchBlock = addDiv(searchArea, "searchBlock", "searchBlock");

    searchBox = addDiv(searchBlock, "searchBox", "searchBox");
    addImage(searchBox, "searchIcon", "search.svg", "iconStyle");
    let searchInput = addInput(searchBox, "searchInput", "Search...", "searchInput");
    searchInput.addEventListener("input", onSearchInput);

    let listBox = addDiv(searchBlock, "listBox", "listBox");
    listBox.addEventListener("transitionend", (e) => {
      if (e.propertyName === "max-height") {
        updateMeshMatrixHeight();
      }
    });
    let listHeader = addDiv(listBox, "listHeader", "listHeader");
    itemCount = addDiv(listHeader, "itemCount", "itemCount");
    itemCount.innerHTML = "Total Meshes: 0/0";
    let headerRight = addDiv(listHeader, "headerRight", "headerRight");
    toggleView = addImage(headerRight, "toggleView", "eyeOpen.svg", "listHeaderIcon");
    unlock = addImage(headerRight, "unlock", "unlock.svg", "listHeaderIcon");
    unlock.style.margin = "0px 9px";

    let listBar = addDiv(listBox, "listBar", "listBar");
    addImage(listBar, "listExpander", "expand.svg", "arrow");
    addLabel(listBar, "Mesh List", "barLabel");

    list = addDiv(listBox, "list", "list");
    var hline = addHorizLine(panelRight.current);
    hline.style.margin = "0px";

    let rowSwitch1 = addDiv(panelRight.current, "rowSwitch", "rowSwitch");
    addLabel(rowSwitch1, "Explode: ", "explodeLabel");
    switchExplode = new Switch(rowSwitch1, "switchExplode", "ON", "OFF", false, true);
    switchExplode.addEventListener("SWITCH_CHANGE", onSwitchChange);

    // let rowSwitch2 = addDiv(panelRight.current, "rowSwitch", "rowSwitch");

    param = addDiv(panelRight.current, "param", "paramBox");
    // addHorizLine(param);

    meshMatrixBar = addDiv(param, "meshMatrixBar", "listBar");
    addImage(meshMatrixBar, "meshMatrixExpander", "expand.svg", "arrow");
    addLabel(meshMatrixBar, "Mesh Matrix", "barLabel");

    meshMatrixBox = addDiv(param, "meshMatrixBox", "meshMatrixBox");

    let rowSwitch = addDiv(meshMatrixBox, "rowSwitch", "rowSwitch");
    addLabel(rowSwitch, "Explode:", "explodeLabel");
    switchParamExplode = new Switch(rowSwitch, "switchParamExplode", "ON", "OFF", false, true);
    switchParamExplode.addEventListener("SWITCH_CHANGE", onSwitchChange);

    let explodeParam = addDiv(meshMatrixBox, "explodeParam", "explodeParam");

    addLabel(explodeParam, "Position:", "param");
    let rowPos = addDiv(explodeParam, "rowPos", "row");
    let snsX = addSNS(rowPos, 3, "snsX", "x", 0, -2048, 2048, 0.1, 1, 1, "px", 50);
    let snsY = addSNS(rowPos, 3, "snsY", "y", 0, -2048, 2048, 0.1, 1, 1, "px", 50);
    let snsZ = addSNS(rowPos, 3, "snsZ", "z", 0, -2048, 2048, 0.1, 1, 1, "px", 50);

    addLabel(explodeParam, "Rotation:", "param");
    let rowRot = addDiv(explodeParam, "rowRot", "row");
    let snsRX = addSNS(rowRot, 3, "snsRX", "x", 0, 0, 360, 1, 10, 0, "°", 30);
    let snsRY = addSNS(rowRot, 3, "snsRY", "y", 0, 0, 360, 1, 10, 0, "°", 30);
    let snsRZ = addSNS(rowRot, 3, "snsRZ", "z", 0, 0, 360, 1, 10, 0, "°", 30);

    addHorizLine(explodeParam);

    let c = 0xff0000;
    let rowRot2 = addDiv(meshMatrixBox, "rowRot", "row");
    addLabel(rowRot2, "Material Color: ", "param");
    colorPicker = addColorPicker(rowRot2, "colorPicker", "colorPicker");
    colorInput = colorPicker.parentNode.children[1];
    colorInput.addEventListener("input", (e) => {
      let color = e.target.value;
      colorPicker.style.background = color;
      let c = color.slice(1);
      let cnum = parseInt(c, 16);
      activeItem.material.color.set(cnum);
      activeItem.userData.color = cnum;
    });

    let rowMat1 = addDiv(meshMatrixBox, "rowRot", "row");
    let snsM = addSNS(rowMat1, 2, "snsM", "metalness", 80, 0, 100, 1, 5, 0, "%", 30);
    let snsR = addSNS(rowMat1, 2, "snsR", "roughness", 50, 0, 100, 1, 5, 0, "%", 30);

    let rowMat2 = addDiv(meshMatrixBox, "rowRot", "row");
    rowMat2.style.gap = "10px";
    addButton(rowMat2, "btnAddTexture", "Add Texture", "btnCopyPaste");
    addButton(rowMat2, "btnRemoveTexture", "Remove Texture", "btnCopyPaste");

    let rowMat3 = addDiv(meshMatrixBox, "rowRot", "row");
    let snsT = addSNS(rowMat3, 3, "snsT", "tile", 1, 1, 1000, 1, 10, 0, "", 50);

    let rowMat4 = addDiv(meshMatrixBox, "rowRot", "row");
    rowMat4.style.gap = "10px";
    addButton(rowMat4, "copyMat", "Copy Material", "btnCopyPaste");
    addButton(rowMat4, "pasteMat", "Paste Material", "btnCopyPaste");

    addHorizLine(param);

    paramAssembly = addDiv(panelRight.current, "paramAssembly", "paramAssembly");

    let asmBar = addDiv(paramAssembly, "asmBar", "listBar");
    addImage(asmBar, "asmArrow", "expand.svg", "arrow");
    addLabel(asmBar, "Assembly", "barLabel");

    let asmMatrix = addDiv(paramAssembly, "asmMatrix", "asmMatrix");

    addLabel(asmMatrix, "Position:", "param");
    let asmRowPos = addDiv(asmMatrix, "asmRowPos", "row");
    let snsAX = addSNS(asmRowPos, 3, "snsAX", "x", 0, -2048, 2048, 0.1, 1, 1, "px", 50);
    let snsAY = addSNS(asmRowPos, 3, "snsAY", "y", 0, -2048, 2048, 0.1, 1, 1, "px", 50);
    let snsAZ = addSNS(asmRowPos, 3, "snsAZ", "z", 0, -2048, 2048, 0.1, 1, 1, "px", 50);

    addLabel(asmMatrix, "Rotation:", "param");
    let asmRowRot = addDiv(asmMatrix, "rowRot", "row");
    let snsARX = addSNS(asmRowRot, 3, "snsARX", "x", 0, 0, 360, 1, 10, 0, "°", 30);
    let snsARY = addSNS(asmRowRot, 3, "snsARY", "y", 0, 0, 360, 1, 10, 0, "°", 30);
    let snsARZ = addSNS(asmRowRot, 3, "snsARZ", "z", 0, 0, 360, 1, 10, 0, "°", 30);

    let rowLeft1 = addDiv(panelLeft.current, "rowLeft1", "userRow");
    addImage(rowLeft1, "profilePhoto", "uzair.jpg", "mvProfilePhoto");
    // addImage(rowLeft1, "profilePhoto", user.photo, "mvProfilePhoto");
    // addLabel(rowLeft1, "Hassan Azzam\nWesleyan University\nBatch(2021) - Final Year", "profileLabel");
    addLabel(rowLeft1, "Muhammad Uzair\nFAST NUCES\nBatch: 2022", "profileLabel");

    let rowLeft2 = addDiv(panelLeft.current, "rowLeft2", "projDetailRow");
    addLabel(rowLeft2, "This 3D assembly model integrates all components of my final year engineering project into a cohesive design, ensuring accurate fitment and alignment. It allowed me to visualize the complete structure, check part compatibility, and verify feasibility before manufacturing, demonstrating practical application of my CAD skills.", "projDetail");
    // addLabel(rowLeft2, project.details);

    // addHorizLine(panelLeft.current);

    let rowLeft3 = addDiv(panelLeft.current, "rowLeft3", "rowleftVert");
    rowLeft3.style.padding = "10px 20px";
    addLabel(rowLeft3, "Viewport Settings", "viewportSettings");
    let snsFOV = addSNS(rowLeft3, 0, "snsFOV", "Camera FOV", 60, 1, 150, 1, 10, 0, "°", 30);
    let snsAmbient = addSNS(rowLeft3, 0, "snsAmbient", "Ambient Light Intensity", 150, 0, 2000, 1, 10, 0, "%", 50);
    let snsDirect = addSNS(rowLeft3, 0, "snsDirect", "Direct Light Intensity", 100, 0, 2000, 1, 10, 0, "%", 50);
    let snsBY = addSNS(rowLeft3, 0, "snsBY", "Ground Y", -2.05, -2048, 2048, 0.01, 1, 2, "", 50);

    let checkBoxes = addDiv(rowLeft3, "checkBoxes", "checkBoxes");

    let chkShadow = addCheckbox(checkBoxes, "chkShadow", "Shadow", true, "checkbox");
    let chkHDRI = addCheckbox(checkBoxes, "chkHDRI", "HDRI", false, "checkbox");
    let chkSkybox = addCheckbox(checkBoxes, "chkSkybox", "Skybox", false, "checkbox");
    let chkSpin = addCheckbox(checkBoxes, "chkSpin", "Spin", false, "checkbox");

    let rowLeft4 = addDiv(panelLeft.current, "rowLeft3", "rowleftHoriz");

    addButton(rowLeft4, "btnLoadAssembly", "Load Assembly", "btnLeft");
    addButton(rowLeft4, "btnDeleteAssembly", "Delete Assembly", "btnLeft");
    addButton(rowLeft4, "btnSaveProject", "Save Project", "btnLeft");
    addButton(rowLeft4, "btnSaveMeshView", "Save Mesh View", "btnLeft");
    addButton(rowLeft4, "btnReset", "Reset Camera", "btnLeft");
    addButton(rowLeft4, "btnSnap", "Viewport Snap", "btnLeft");

    paramLock = addDiv(meshMatrixBox, "paramLock", "paramLock");

    let tools = addDiv(toolsDiv.current, "tools", "tools");
    let explodeIcon = addImage(tools, "explodeIcon", "explodeOff.svg", "toolIcons");
    let translate = addImage(tools, "translate", "dragOn.svg", "toolIcons");
    let rotate = addImage(tools, "rotate", "rotate.svg", "toolIcons");
    let help = addImage(tools, "help", "help.svg", "toolIcons");

    helpBox = addDiv(app.current, "helpBox", "helpBox");
    helpSheet = addDiv(helpBox, "helpSheet", "helpSheet");
    helpSheet.addEventListener("transitionend", (e) => {
      if (e.propertyName === "transform") {
        let style = window.getComputedStyle(helpSheet);
        let transform = style.transform;
        let values = transform.split("(")[1].split(")")[0].split(",");
        let scaleX = parseFloat(values[0]);
        if (scaleX == 0) {
          helpBox.style.display = "none";
        }
      }
    });
    let helpRow1 = addDiv(helpSheet, "helpRow1", "helpRow");
    helpRow1.style.justifyContent = "center";
    addLabel(helpRow1, "Help", "helpTitle");
    addImage(helpRow1, "exitHelp", "close.svg", "exitHelp");
    let helpRow2 = addDiv(helpSheet, "helpRow2", "helpPicRow");
    addImage(helpRow2, "helpPic", "helpPic.jpg", "helpPic");

    let gallery = new Gallery();
    gallery.appendTo(document.body);

    fetch(`${process.env.PUBLIC_URL}/json/gallery.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch gallery.json");
        }
        return response.json();
      })
      .then((data) => {
        gallery.data(data);
      })
      .catch((error) => console.error("Error:", error));

    tag = addDiv(document.body, "tag", "tag");
    setDisable(false);

    gizmo = new Gizmo();
    gizmo.appendTo(gizmoDiv.current);

    gizmo.moveToView("prespective", camera, controls);

    let texInput = document.createElement("input");
    texInput.type = "file";
    texInput.accept = ".png, .jpg";
    texInput.style.display = "none";
    texInput.addEventListener("change", function (event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let arrayBuffer = e.target.result;
        let blob = new Blob([arrayBuffer]);
        createImageBitmap(blob).then((imageBitmap) => {
          let bakeCanvas = document.createElement("canvas");
          bakeCanvas.width = imageBitmap.width;
          bakeCanvas.height = imageBitmap.height;
          let ctx = bakeCanvas.getContext("2d");
          ctx.drawImage(imageBitmap, 0, 0);
          setTimeout(() => {
            let dataURL = bakeCanvas.toDataURL("image/png");
            activeItem.userData.texture = dataURL;
            texInput.value = "";
            applyTexture(activeItem, dataURL);
          }, 10);
        });
      };
      reader.readAsArrayBuffer(file);
    });

    let fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".glb, .gltf, .stl";
    fileInput.style.display = "none";
    fileInput.addEventListener("change", function (event) {
      setShowPreloader(true);
      showMeshName = false;
      let file = event.target.files[0];
      extension = file.name.split(".").pop().toLowerCase();

      let reader = new FileReader();
      reader.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = Math.round((event.loaded / event.total) * 100);
        }
      };
      reader.onload = function (ev) {
        setShowPreloader(false);

        header.appendChild(logo);

        showMeshName = true;
        arrayBuffer = ev.target.result;
        if (assemblyRoot.children.length === 0) {
          if (extension == "glb" || extension == "gltf") {
            loadGLBModelByArrayBuffer(arrayBuffer);
          } else if (extension == "stl") {
            loadSTLModelByArrayBuffer(arrayBuffer);
          }
        } else {
          showMeshName = false;
          popup.show("Do you want to keep the existing model", [
            { id: "loadPopupYes", caption: "Yes" },
            { id: "loadPopupNo", caption: "No" },
            { id: "loadPopupCancel", caption: "Cancel" },
          ]);
        }
        fileInput.value = "";
      };
      reader.readAsArrayBuffer(file);
    });

    // let fileExtension = project.assembly.split(".").pop();
    // if (fileExtension == "glb") {
    //   loadGLBModel("/models/" + project.assembly);
    // } else if (fileExtension == "stl") {
    //   loadSTLModel("/models/" + project.assembly);
    // }

    loadGLBModel(getAsset("drill_machine.glb", "models"));
    // loadGLBModel("/models/Assembly.glb");
    // loadGLBModel("/models/drill_machine.glb");
    // loadSTLModel("/models/pine.stl");
    // localStorage.removeItem("pine");
    let pine = localStorage.getItem("pine");
    let data = null;
    // if(pine){
    //   data = JSON.parse(pine)[0];
    //   if(data.gltf){
    //     loadGLBModelByArrayBuffer(data.gltf);
    //   }
    // }

    let viewportFOV, viewportAIntensity, viewportDIntensity, viewportGY;
    let vpCheckBoxes, vpChkShadow, vpChkHDRI, vpChkSkybox, vpChkSpin;
    if (viewportPage.current) {
      viewportFOV = new RangeSlider("viewportFOV", "Camear FOV", 0, 100, 60, "°", "12vw");
      viewportFOV.appendTo(viewportPage.current);
      // viewportFOV.setValue(60);
      viewportFOV.addEventListener("change", onRangeChange);

      viewportAIntensity = new RangeSlider("viewportAIntensity", "Ambient Intensity", 0, 200, 15, "%", "14vw");
      viewportAIntensity.appendTo(viewportPage.current);
      viewportAIntensity.addEventListener("change", onRangeChange);

      viewportDIntensity = new RangeSlider("viewportDIntensity", "Direct Intensity", 0, 200, 1, "%", "14vw");
      viewportDIntensity.appendTo(viewportPage.current);
      viewportDIntensity.addEventListener("change", onRangeChange);

      viewportGY = new RangeSlider("viewportGY", "Ground Y", -2048, 2048, 0, "px", "18vw");
      viewportGY.appendTo(viewportPage.current);
      viewportGY.addEventListener("change", onRangeChange);

      vpCheckBoxes = addDiv(viewportPage.current, "vpCheckBoxes", "vpCheckBoxes");

      vpChkShadow = addCheckbox(vpCheckBoxes, "chkShadow", "Shadow", true, "checkbox");
      vpChkHDRI = addCheckbox(vpCheckBoxes, "chkHDRI", "HDRI", false, "checkbox");
      vpChkSkybox = addCheckbox(vpCheckBoxes, "chkSkybox", "Skybox", false, "checkbox");
      vpChkSpin = addCheckbox(vpCheckBoxes, "chkSpin", "Spin", false, "checkbox");
    }
    if (listPage.current) {
      // addInput(listPage.current, "searchBox", "Search...", "");
      listMini = new ListMini();
      if (listPage.current) {
        listMini.appendTo(listPage.current);
      }
    }
    if (assemblyPage.current) {
      x_a = new RangeSlider("x_a", "x", -2048, 2048, 0, "px", "18vw");
      x_a.addEventListener("change", onRangeChange);
      x_a.appendTo(assemblyPage.current);

      y_a = new RangeSlider("y_a", "y", -2048, 2048, 0, "px", "18vw");
      y_a.addEventListener("change", onRangeChange);
      y_a.appendTo(assemblyPage.current);

      z_a = new RangeSlider("z_a", "z", -2048, 2048, 0, "px", "18vw");
      z_a.addEventListener("change", onRangeChange);
      z_a.appendTo(assemblyPage.current);

      rx_a = new RangeSlider("rx_a", "rx", 0, 360, 0, "°", "16vw");
      rx_a.addEventListener("change", onRangeChange);
      rx_a.appendTo(assemblyPage.current);

      ry_a = new RangeSlider("ry_a", "ry", 0, 360, 0, "°", "16vw");
      ry_a.addEventListener("change", onRangeChange);
      ry_a.appendTo(assemblyPage.current);

      rz_a = new RangeSlider("rz_a", "rz", 0, 360, 0, "°", "16vw");
      rz_a.addEventListener("change", onRangeChange);
      rz_a.appendTo(assemblyPage.current);
    }
    if (meshPage.current) {
      let div = addDiv(meshPage.current, "meshParam", "meshParam");

      let row1 = addDiv(div, "rowMesh1", "rowMesh");
      row1.style.marginLeft = "1vh";
      addImage(row1, "addTexture", "addTexture.svg", "iconMesh");
      addImage(row1, "removeTexture", "removeTexture.svg", "iconMesh");
      addImage(row1, "copyMat_m", "copy.svg", "iconMesh");
      addImage(row1, "pasteMat_m", "paste.svg", "iconMesh");
      if (orientation == "portrait") {
        row1.appendChild(colorPicker);
      }

      let tile = new RangeSlider("tile_m", "tile", 1, 1000, 0, "", "14vw");
      tile.addEventListener("change", onRangeChange);
      tile.appendTo(div);

      let metalness = new RangeSlider("metalness_m", "metalness", 0, 100, 0, "%", "14vw");
      metalness.addEventListener("change", onRangeChange);
      metalness.appendTo(div);

      let roughness = new RangeSlider("roughness_m", "roughness", 0, 100, 0, "%", "14vw");
      roughness.addEventListener("change", onRangeChange);
      roughness.appendTo(div);

      let row2 = addDiv(div, "rowMesh1", "rowMesh");
      row2.style.width = "22vh";
      addLabel(row2, "Explode", "meshLabel");
      switchExplode = new Switch(row2, "switchExplode_m", "ON", "OFF", false, true);
      switchExplode.addEventListener("SWITCH_CHANGE", onSwitchChange);

      explodeParam_m = addDiv(div, "explodeParam_m", "explodeParam_m");

      x_m = new RangeSlider("x_m", "x", -2048, 2048, 0, "px", "18vw");
      x_m.addEventListener("change", onRangeChange);
      x_m.appendTo(explodeParam_m);

      y_m = new RangeSlider("y_m", "y", -2048, 2048, 0, "px", "18vw");
      y_m.addEventListener("change", onRangeChange);
      y_m.appendTo(explodeParam_m);

      z_m = new RangeSlider("z_m", "z", -2048, 2048, 0, "px", "18vw");
      z_m.addEventListener("change", onRangeChange);
      z_m.appendTo(explodeParam_m);

      rx_m = new RangeSlider("rx_m", "rx", 0, 360, 0, "°", "16vw");
      rx_m.addEventListener("change", onRangeChange);
      rx_m.appendTo(explodeParam_m);

      ry_m = new RangeSlider("ry_m", "ry", 0, 360, 0, "°", "16vw");
      ry_m.addEventListener("change", onRangeChange);
      ry_m.appendTo(explodeParam_m);

      rz_m = new RangeSlider("rz_m", "rz", 0, 360, 0, "°", "16vw");
      rz_m.addEventListener("change", onRangeChange);
      rz_m.appendTo(explodeParam_m);
    }
    function onRangeChange(e) {
      console.log(e.detail.id);
      console.log(e.detail.value);
      let id = e.detail.id;
      let value = e.detail.value;
      console.log(id);
      console.log(value);
      msg.current.innerHTML = id;
      if (id == "viewportFOV") {
        camera.fov = value;
        camera.updateProjectionMatrix();
      } else if (id == "viewportAIntensity") {
        ambient.intensity = value / 10;
      } else if (id == "viewportDIntensity") {
        lightTop.intensity = lightBottom.intensity = lightLeft.intensity = lightRight.intensity = lightFront.intensity = lightBack.intensity = value / 100;
      } else if (id == "viewportGY") {
        plane.position.y = value / 10;
      } else if (id == "tile_m") {
        msg.current.innerHTML = "Tile: " + value;
        setTile(value);
      } else if (id == "metalness_m") {
        activeItem.material.metalness = activeItem.userData.metalness = value / 100;
      } else if (id == "roughness_m") {
        activeItem.material.roughness = activeItem.userData.roughness = value / 100;
      } else if (id == "x_m") {
        activeItem.position.x = activeItem.userData.x2 = value;
      } else if (id == "y_m") {
        activeItem.position.y = activeItem.userData.y2 = value;
      } else if (id == "z_m") {
        activeItem.position.z = activeItem.userData.z2 = value;
      } else if (id == "rx_m") {
        activeItem.rotation.x = value * deg2Rad;
        activeItem.userData.rx2 = value;
      } else if (id == "ry_m") {
        activeItem.rotation.y = value * deg2Rad;
        activeItem.userData.ry2 = value;
      } else if (id == "rz_m") {
        activeItem.rotation.z = value * deg2Rad;
        activeItem.userData.rz2 = value;
      } else if (id == "x_a") {
        assembly.position.x = value / 100;
      } else if (id == "y_a") {
        assembly.position.y = value / 100;
      } else if (id == "z_a") {
        assembly.position.z = value / 100;
      } else if (id == "rx_a") {
        assembly.rotation.x = value * deg2Rad;
      } else if (id == "ry_a") {
        assembly.rotation.y = value * deg2Rad;
      } else if (id == "rz_a") {
        assembly.rotation.z = value * deg2Rad;
      }
    }

    window.addEventListener("resize", resize);
    window.addEventListener("touchstart", startPress);
    window.addEventListener("touchend", cancelPress);
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("dblclick", onDoubleClick);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    document.addEventListener("fullscreenchange", onFullscreenChange);

    let animate = () => {
      animateRef.current = requestAnimationFrame(animate);
      TWEEN.update();
      controls.update();
      renderer.render(scene, camera);
      if (gizmo) {
        try {
          gizmo.spinGizmo = camera;
        } catch (err) {}
      }
      if (spin) {
        spinangle += 0.5;
        if (spinangle == 360) spinangle = 0;
        if (view) {
          view.rotation.y = (spinangle / 180) * Math.PI;
        }
      }
    };
    function cancelPress() {
      clearTimeout(pressTimer);
    }
    function loadGalleryTexture(url) {
      let image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);
        let dataURL = canvas.toDataURL();
        applyTexture(activeItem, dataURL);
      };
      image.onerror = function () {
        console.error("Failed to load image:", url);
      };
      image.src = url;
    }
    function applyTexture(item, dataURL) {
      let image = new Image();
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);
        let texture = new THREE.CanvasTexture(canvas);
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        let tile = item.userData.tile / 1000;
        texture.repeat.set(tile, tile);
        item.userData.texture = dataURL;
        item.material.map = texture;
        item.material.needsUpdate = true;
      };
      image.src = dataURL;
    }
    function loadHDRI(file) {
      let loader = new UltraHDRLoader();
      loader.setDataType(THREE["HalfFloatType"]);
      const url = getAsset(file, "hdr");
      console.log(url);
      loader.load(url, function (texture) {
        //   loader.load("/hdr/" + file, function (texture) {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        texture.needsUpdate = true;
        hdri = texture;
      });
    }
    function addBase() {
      let planeGeo = new THREE.PlaneGeometry(2000, 2000);
      let planeMat = new THREE.MeshStandardMaterial({ color: 0xffffff });
      plane = new THREE.Mesh(planeGeo, planeMat);
      plane.rotation.x = -Math.PI / 2;
      // plane.position.y = -2.05;
      plane.receiveShadow = true;
      scene.add(plane);
    }
    function setNewLabel(lbl) {
      showMeshName = false;
      if (activeNameInput) {
        let str = lbl.trim().replace(/\s+/g, "_");
        activeNameInput.value = str;
        let firstChar = str.charAt(0);
        let exists = items.some((mesh) => mesh !== activeItem && mesh.name === str);
        if (str.length == 0) {
          showNameError("You have to enter any valid name");
        } else if (exists) {
          showNameError("Name already exists");
        } else if (!isNaN(firstChar)) {
          showNameError("The name cannot start with a number");
        } else {
          activeItem.name = str;
          let lst = activeListItem.parentNode;
          lst.id = activeNameInput.value;
          activeNameInput.removeEventListener("blur", onListFocusOut);
          activeNameInput = null;

          lst.children[2].innerText = str;
          lst.children[1].style.display = "none";
          lst.children[2].style.display = "flex";

          items.sort((a, b) => a.name.localeCompare(b.name));
          filteredList = items.filter((item) => item.name.toLowerCase().includes(searchInput.value.toLowerCase()));
          reloadList();
          lst = document.querySelector("#list #" + str);
          activeListItem = lst.children[2];
          activeListItem.classList.add("selected");
          return;
        }
        activeNameInput.removeEventListener("blur", onListFocusOut);
        activeNameInput = null;
      }
    }
    function showNameError(error) {
      popup.show(error, [{ id: "closePopup", caption: "Ok" }]);
    }
    function onListFocusOut(e) {
      setNewLabel(activeNameInput.value);
    }
    function checkAllLock() {
      let v = true;
      for (let i = 0; i < filteredList.length; i++) {
        let item = filteredList[i];
        if (!item.userData.lock) {
          v = false;
          break;
        }
      }
      allLock = v;
      //   unlock.src = allLock ? "/images/lock.svg" : "/images/unlock.svg";
      unlock.src = allLock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
    }
    function checkAllHide() {
      let v = false;
      for (let i = 0; i < filteredList.length; i++) {
        let item = filteredList[i];
        if (item.userData.visible) {
          v = true;
          break;
        }
      }
      allvisible = v;
      toggleView.src = allvisible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
    }
    function resize() {
      var vw = parseInt(window.innerWidth);
      var vh = parseInt(window.innerHeight);
      renderer.setSize(vw, vh);
      camera.aspect = vw / vh;
      camera.updateProjectionMatrix();
      if (meshMatrixBox) {
        updateMeshMatrixHeight();
      }
      if (window.screen.width > window.screen.height) {
        // panelLeft.current.style.display = "block";
        console.log(searchBlock);
        userPage.current.style.display = "none";
        filePage.current.style.display = "none";
        viewportPage.current.style.display = "none";
        listPage.current.style.display = "none";

        if (window.matchMedia("(orientation: portrait)").matches) {
          console.log("Portrait mode");
          // panelLeft.current.style.display = "none";
          userPage.current.style.display = "block";
          filePage.current.style.display = "block";
          viewportPage.current.style.display = "block";
          listPage.current.style.display = "block";
        } else {
          console.log("Landscape mode");
          panelLeft.current.style.display = "block";
          console.log(searchBlock);
          userPage.current.style.display = "none";
          filePage.current.style.display = "none";
          viewportPage.current.style.display = "none";
          listPage.current.style.display = "none";
        }
      } else {
        // listPage.current.appendChild(searchBlock);
        console.log("I m here");
        // addInput(listPage.current, "searchBox", "Search...","");
        // panelLeft.current.style.display = "none";

        userPage.current.style.display = "block";
        filePage.current.style.display = "block";
        viewportPage.current.style.display = "block";
        listPage.current.style.display = "block";
      }
      if (msg.current) {
        msg.current.innerText = window.screen.height + "  " + window.screen.width;
      }
    }
    function createMeshData(mesh) {
      mesh.geometry = mesh.geometry.clone();
      mesh.geometry.deleteAttribute("uv");
      meshes.push({
        name: mesh.name,
        lock: mesh.userData.lock ? 1 : 0,
        visible: mesh.userData.visible ? 1 : 0,
        color: mesh.userData.color,
        metalness: mesh.userData.metalness,
        roughness: mesh.userData.roughness,
        texture: mesh.userData.texture,
        tile: mesh.userData.tile,
        x1: mesh.userData.x1,
        x2: mesh.userData.x2,
        y1: mesh.userData.y1,
        y2: mesh.userData.y2,
        z1: mesh.userData.z1,
        z2: mesh.userData.z2,
        rx1: mesh.userData.rx1,
        rx2: mesh.userData.rx2,
        ry1: mesh.userData.ry1,
        ry2: mesh.userData.ry2,
        rz1: mesh.userData.rz1,
        rz2: mesh.userData.rz2,
        focus: mesh.userData.focus,
      });
    }
    function onMouseDown(e) {
      // e.preventDefault();
      let id = e.target.id;
      console.log(id);
      msg.current.innerHTML = id;
      let itemType = e.target.getAttribute("itemType");
      if (id == "canvas") {
        console.log("i m here");
        showTag(e);
      } else if (id == "explodeIcon") {
        exploded = !exploded;
        for (let i = 0; i < items.length; i++) {
          explode(exploded, items[i]);
        }
      } else if (id == "logo") {
        showMeshName = false;
        if (!isFullscreen.current) {
          popup.show("You haven't saved the project.\nDo you want to quit Model View?", [
            { id: "quitAppYes", caption: "Yes" },
            { id: "quitAppNo", caption: "No" },
          ]);
        }
      } else if (id == "quitAppYes") {
        popup.hide();
        // navigate("/");
      } else if (id == "quitAppNo") {
        popup.hide();
        showMeshName = true;
      } else if (id == "btnSaveProject") {
        saveProj();
      } else if (id === "loadPopupYes") {
        popup.hide();
        if (extension == "glb") {
          loadGLBModelByArrayBuffer(arrayBuffer);
        } else if (extension == "stl") {
          loadSTLModelByArrayBuffer(arrayBuffer);
        }
        showMeshName = true;
      } else if (id === "loadPopupNo") {
        clearView();
        popup.hide();
        if (extension == "glb" || extension == "gltf") {
          loadGLBModelByArrayBuffer(arrayBuffer);
        } else if (extension == "stl") {
          loadSTLModelByArrayBuffer(arrayBuffer);
        }
        showMeshName = true;
      } else if (id === "loadPopupCancel") {
        popup.hide();
      } else if (id === "toggleView") {
        allvisible = !allvisible;
        toggleView.src = allvisible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
        for (let i = 0; i < filteredList.length; i++) {
          // filteredList[i].visible = allvisible;
          filteredList[i].userData.visible = allvisible;
          if (allvisible) {
            assemblyRoot.add(filteredList[i]);
          } else {
            hidden.add(filteredList[i]);
          }
        }
        let listItems = list.children;
        for (let i = 0; i < listItems.length; i++) {
          let item = listItems[i];
          let img = item.children[3];
          img.src = allvisible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
        }
      } else if (itemType === "eye") {
        let mesh = scene.getObjectByName(e.target.parentNode.id);
        let meshState = mesh.userData.visible;
        meshState = !meshState;
        // mesh.visible = meshState;
        mesh.userData.visible = meshState;
        if (meshState) {
          assemblyRoot.add(mesh);
        } else {
          hidden.add(mesh);
        }
        e.target.src = meshState ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
        checkAllHide();
      } else if (id === "unlock") {
        if (items.length > 0) {
          allLock = !allLock;
          unlock.src = allLock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
          if (allLock) {
            transform.detach();
            transformOn = false;
          } else {
            if (activeItem) {
              transform.attach(activeItem);
              transformOn = true;
            }
          }
          setDisable(allLock);

          for (let i = 0; i < filteredList.length; i++) {
            filteredList[i].userData.lock = allLock;
          }
          let listItems = list.children;
          for (let i = 0; i < listItems.length; i++) {
            let item = listItems[i];
            let img = item.children[4];
            img.src = allLock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
          }
        }
      } else if (itemType === "lock") {
        let mesh = scene.getObjectByName(e.target.parentNode.id);
        let meshState = mesh.userData.lock;
        meshState = !meshState;
        mesh.userData.lock = meshState;
        if (!meshState) {
          transform.attach(mesh);
          transformOn = true;
        } else {
          transform.detach();
          transformOn = false;
        }
        e.target.src = meshState ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
        if (mesh == activeItem) {
          setDisable(meshState);
        }
        checkAllLock();
      } else if (itemType === "listItem") {
        if (activeNameInput === null) {
          setActiveItem(e.target.id);
        } else {
          activeNameInput.removeEventListener("blur", onListFocusOut);
          setNewLabel(activeNameInput.value);
        }
      } else if (itemType === "listMiniItem") {
        listMini.selectMesh(e.target);
        meshName.current.innerHTML = "Mesh - " + e.target.children[2].innerText;
        setActiveMiniItem(e.target.children[2].innerText, false);
      } else if (itemType == "galleryTexture") {
        console.log(id);
        gallery.hide();
        showMeshName = true;
        loadGalleryTexture(id);
      } else if (id === "colorPicker") {
        colorInput.click();
        msg.current.innerText = "I m Color Picker";
      } else if (id === "fullscreen") {
        isFullscreen.current = !isFullscreen.current;
        if (isFullscreen.current) {
          switchFullScreen();
        } else {
          switchNormScreen();
        }
      } else if (id === "listBar") {
        e.target.children[0].classList.toggle("active");
        let lopen = e.target.children[0].classList.length == 1 ? false : true;
        listBox.style.maxHeight = lopen ? 0 : "310px";
      } else if (id === "meshMatrixBar") {
        e.target.children[0].classList.toggle("active");
        let mopen = e.target.children[0].classList.length == 1 ? false : true;
        meshMatrixBox.style.maxHeight = mopen ? 0 : 330 + "px";
      } else if (id == "copyMat" || id == "copyMat_m") {
        copyMaterial();
      } else if (id == "pasteMat" || id == "pasteMat_m") {
        pasteMaterial();
      } else if (id == "btnAddTexture" || id == "addTexture") {
        // texInput.click();
        // console.log("btn add texture")
        // gallery.show();
        showMeshName = false;
        popup.show("How would you like to add the texture?", [
          { id: "localTexture", caption: "Local" },
          { id: "galleryTexture", caption: "Gallery" },
          { id: "loadPopupCancel", caption: "Cancel" },
        ]);
      } else if (id == "localTexture") {
        popup.hide();
        texInput.click();
      } else if (id == "galleryTexture") {
        showMeshName = false;
        popup.hide();
        gallery.show();
      } else if (id == "btnRemoveTexture" || id == "removeTexture") {
        if (activeItem && activeItem.material) {
          activeItem.material.map = null;
          activeItem.material.needsUpdate = true;
        }
      } else if (id == "btnReset") {
        camera.position.copy(reset.position);
        controls.target.copy(reset.target);
        view.rotation.y = 0;
      } else if (id == "btnSaveMeshView") {
        if (activeItem) {
          let focus = { p: camera.position.clone(), t: controls.target.clone() };
          activeItem.userData.focus = focus;
        }
      } else if (id == "btnLoadAssembly") {
        fileInput.click();
      } else if (id == "btnDeleteAssembly") {
        console.log("Delete Assembly");
        showMeshName = false;
        popup.show("Are you sure to delete Assembly\nThis action cannot be undone.", [
          { id: "btnResetYes", caption: "Yes" },
          { id: "btnResetNo", caption: "No" },
        ]);
      } else if (id == "btnResetYes") {
        showMeshName = true;
        resetAll();
        popup.hide();
      } else if (id == "btnResetNo") {
        showMeshName = true;
        popup.hide();
      } else if (id == "del") {
        delMeshName = e.target.parentNode.children[2].innerText;
        confirmMeshDelete();
      } else if (id == "delMeshYes") {
        meshDelConfirm();
      } else if (id == "delMeshNo") {
        showMeshName = true;
        popup.hide();
      } else if (id == "rotate") {
        transform.setMode("rotate");
        translate.src = getAsset("drag.svg", "images");
        rotate.src = getAsset("rotateOn.svg", "images");
      } else if (id == "translate") {
        transform.setMode("translate");
        translate.src = getAsset("dragOn.svg", "images");
        rotate.src = getAsset("rotate.svg", "images");
      } else if (id == "asmBar") {
        e.target.children[0].classList.toggle("active");
        let mopen = e.target.children[0].classList.length == 1 ? true : false;
        asmMatrix.style.maxHeight = mopen ? "100px" : "0px";
      } else if (id == "help") {
        showHelp();
      } else if (id == "exitHelp") {
        helpSheet.classList.remove("show");
        showMeshName = true;
      } else if (id == "exitGallery") {
        gallery.hide();
        showMeshName = true;
      } else if (id == "btnSnap") {
        takeSnapshot();
      } else if (id == "menuUser") {
        showPage(userPage.current, "0px");
      } else if (id == "menuFile") {
        showPage(filePage.current, "0px");
      } else if (id == "menuViewport") {
        showPage(viewportPage.current, "0px");
      } else if (id == "menuSearch") {
        showPage(listPage.current, "0px");
      } else if (id == "menuAssembly") {
        if (menuAssembly.getAttribute("enable") == "true") {
          showPage(assemblyPage.current, "0px");
        }
      } else if (id == "menuMesh") {
        if (menuMesh.getAttribute("enable") == "true") {
          showPage(meshPage.current, "0px");
        }
      } else if (id == "close") {
        e.target.parentNode.style.bottom = "-60vh";
      } else if (itemType == "chkbox") {
        let div = e.target;
        let tick = div.children[0].children[0];
        console.log(tick.style.opacity);
        let checked = tick.style.opacity == 1 ? true : false;
        checked = !checked;
        tick.style.opacity = checked ? 1 : 0;
        // checked = !checked;
        // chkbox.checked = checked;
        if (id == "chkShadow") {
          plane.visible = checked;
        } else if (id == "chkSpin") {
          // spinangle = 0;
          spin = checked;
        } else if (id == "chkHDRI") {
          scene.environment = checked ? hdri : null;
        } else if (id == "chkSkybox") {
          scene.background = checked ? hdri : null;
        }
      } else if (id == "view") {
        listMini.toggleViewAll();
      } else if (id == "lock") {
        let filename = e.target.src.split("/").pop();
        let s = filename == "lock.svg" ? true : false;
        s = !s;
        if (s) {
          transform.detach();
          transformOn = false;
        } else {
          transform.attach(activeItem);
          transformOn = true;
        }
        listMini.toggleLockAll();
      } else if (id == "miniView") {
        listMini.applyView(e.target);
      } else if (id == "miniLock") {
        let name = e.target.parentNode.parentNode.children[2].innerText;
        console.log(name);
        let mesh = scene.getObjectByName(name);
        setEmissive(mesh, true, selectedColor);
        let s = mesh.userData.lock;
        s = !s;
        if (s) {
          transform.detach();
          transformOn = false;
        } else {
          transform.attach(mesh);
          transformOn = true;
        }
        listMini.applyLock(e.target);
      } else if (id == "miniDel") {
        let meshName = e.target.parentNode.parentNode.children[2].innerText;
        activeItem = scene.getObjectByName(meshName);
        delMeshName = activeItem.name;
        confirmMeshDelete();
      }
    }
    function copyMaterial() {
      copiedMat = {
        color: activeItem.userData.color,
        metalness: activeItem.userData.metalness,
        roughness: activeItem.userData.roughness,
        texture: activeItem.userData.texture,
        tile: activeItem.userData.tile,
      };
    }
    function pasteMaterial() {
      colorPicker.style.background = "#" + copiedMat.color.toString(16).padStart(6, "0").toUpperCase();
      activeItem.material.color.set(copiedMat.color);
      activeItem.userData.color = copiedMat.color;
      activeItem.material.metalness = activeItem.userData.metalness = copiedMat.metalness;
      snsM.value = copiedMat.metalness * 100;
      activeItem.material.roughness = activeItem.userData.roughness = copiedMat.roughness;
      snsR.value = copiedMat.roughness * 100;
      // activeItem.material.map = copiedMat.texture;
      activeItem.material.tile = snsT.value = activeItem.userData.tile = copiedMat.tile;
      activeItem.userData.texture = copiedMat.texture;
      applyTexture(activeItem, copiedMat.texture);
    }
    function startPress(e) {
      // e.preventDefault();
      if (!transformOn) {
        cancelPress();
        if (e.target.id == "canvas") {
          pressTimer = setTimeout(() => {
            let touch = e.touches[0];
            mouse.x = (touch.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(touch.clientY / window.innerHeight) * 2 + 1;
            raycaster.setFromCamera(mouse, camera);
            let intersects = raycaster.intersectObjects(assemblyRoot.children, true);
            if (intersects.length > 0) {
              transform.attach(assembly);
              transformOn = true;
              let s = window.getComputedStyle(panelLeft.current);
              if (s.display == "block") {
              } else {
                menuAssembly.style.filter = "none";
                menuAssembly.setAttribute("enable", true);
                showPage(assemblyPage.current, "0px");

                menuMesh.style.filter = "grayscale(100%)";
                menuMesh.setAttribute("enable", false);
                meshPage.current.style.bottom = "-60vh";
                selectedType = "assembly";
                msg.current.innerHTML = "I am in Assembly";
              }
            } else {
              transform.detach();
              transformOn = false;
              menuAssembly.style.filter = "grayscale(100%)";
              menuAssembly.setAttribute("enable", false);
              assemblyPage.current.style.bottom = "-60vh";
            }
          }, 250);
        }
      }
    }
    function showPage(page, bottom) {
      if (activePage.current) {
        activePage.current.style.bottom = "-60vh";
      }
      activePage.current = page;
      page.style.bottom = bottom;
    }
    function resetAll() {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        item.geometry.dispose();
        item.material.dispose();
        assemblyRoot.remove(item);
      }
      let data = JSON.parse(pine);
      data[0].gltf = null;
      data[0].meshes = null;
      localStorage.setItem("pine", JSON.stringify(data));
      items = [];
      filteredList = [];
      reloadList();
      camera.position.copy(reset.position);
      controls.target.copy(reset.target);
      view.rotation.y = 0;
      itemCount.innerHTML = "Total Meshes: 0 / 0";
      paramAssembly.style.display = "none";
    }
    function saveProj() {
      let data = [];
      meshes = [];
      data.push({
        fov: snsFOV.value,
        a: snsAmbient.value,
        d: snsDirect.value,
        g: snsBY.value,
        shadow: chkShadow.children[0].checked,
        hdri: chkHDRI.children[0].checked ? 1 : 0,
        skybox: chkSkybox.children[0].checked ? 1 : 0,
        spin: chkSpin.children[0].checked ? 1 : 0,
        cameraPosition: camera.position.clone(),
        controlTarget: controls.target.clone(),
        ax: snsAX.value,
        ay: snsAY.value,
        az: snsAZ.value,
        arx: snsARX.value,
        ary: snsARY.value,
        arz: snsARZ.value,
        gltf: null,
        meshes: null,
      });
      while (hidden.children.length > 0) {
        const child = hidden.children[0];
        assemblyRoot.add(child);
      }
      let cloneAssemblyRoot = assemblyRoot.clone(true);
      cloneAssemblyRoot.traverse((child) => {
        if (child.isMesh) {
          createMeshData(child);
        }
      });
      data[0].meshes = meshes;
      exporter.parse(
        cloneAssemblyRoot,
        (gltf) => {
          let output = JSON.stringify(gltf, null, 2);
          data[0].gltf = output;
          localStorage.setItem("pine", JSON.stringify(data));
          disposeCloneGroup(cloneAssemblyRoot);
          let i = 0;
          while (i < assemblyRoot.children.length) {
            const child = assemblyRoot.children[i];
            if (child.userData.visible === false) {
              hidden.add(child);
            } else {
              i++;
            }
          }
        },
        { binary: false },
      );
    }
    function disposeCloneGroup(group) {
      group.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) {
            child.geometry.dispose(); // free geometry
          }
          if (child.material) {
            // If material is an array (e.g., multi-material)
            if (Array.isArray(child.material)) {
              child.material.forEach((mat) => mat.dispose());
            } else {
              child.material.dispose(); // free material
            }
          }
          if (child.texture) {
            child.texture.dispose(); // optional: if you manually attached a texture
          }
        }
      });

      // if (group.parent) {
      //   group.parent.remove(group); // remove from scene or parent
      // }
    }
    function saveBlob(blob, filename) {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    }
    function meshDelConfirm() {
      transform.detach();
      transformOn = false;
      showMeshName = true;
      popup.hide();
      let itm = assemblyRoot.getObjectByName(delMeshName);
      itm.geometry.dispose();
      itm.material.dispose();
      assemblyRoot.remove(itm);
      items = delMesh(items, delMeshName);
      filteredList = items;
      listMini.setItems(items, assemblyRoot, hidden, scene);
      reloadList();
    }
    function confirmMeshDelete() {
      showMeshName = false;
      popup.show("Do you really want to delete the mesh?\nThis action cannot be undone.", [
        { id: "delMeshYes", caption: "Yes" },
        { id: "delMeshNo", caption: "No" },
      ]);
    }
    function takeSnapshot() {
      let dataURL = viewport.toDataURL("image/png");
      let link = document.createElement("a");
      link.href = dataURL;
      link.download = "pine.png";
      link.click();
    }
    function showHelp() {
      showMeshName = false;
      app.current.appendChild(helpBox);
      helpBox.style.display = "flex";
      helpBox.style.zIndex = 1000;
      setTimeout(() => {
        helpSheet.classList.add("show");
      }, 10);
    }
    function onFullscreenChange(e) {
      setScreen();
    }
    function switchFullScreen() {
      if (app.current && app.current.requestFullscreen) {
        app.current.requestFullscreen();
      }
    }
    function switchNormScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
    function setScreen() {
      if (window.screen.height == window.innerHeight) {
        chkSpin.children[0].checked = true;
        spinangle = 0;
        spin = true;
        gizmo.show(false);
        panelLeft.current.style.display = "none";
        panelRight.current.style.display = "none";
        tools.style.display = "none";
        header.style.width = "100%";
        header.style.left = 0;
        isFullscreen.current = true;
        fullscreen.src = getAsset("normscreen.svg", "images");
      } else {
        chkSpin.children[0].checked = false;
        spin = false;
        gizmo.show(true);
        panelLeft.current.style.display = "block";
        panelRight.current.style.display = "block";
        tools.style.display = "flex";
        tools.style.flexDirection = "column";
        header.style.width = "calc(100% - 600px)";
        header.style.left = "300px";
        isFullscreen.current = false;
        fullscreen.src = getAsset("fullscreen.svg", "images");
      }
    }
    function searchMesh(group, name) {
      return group.children.some((child) => child.name === name);
    }
    function getUniqueName(baseName, assemblyRoot) {
      if (!searchMesh(assemblyRoot, baseName)) {
        return baseName;
      }
      return getUniqueName(baseName + "_1", assemblyRoot);
    }
    function delMesh(arr, name) {
      return arr.filter((item) => item.name !== name);
    }
    function onMouseMove(e) {
      let itemType = e.target.getAttribute("itemType");
      if (e.clientX > 300 && e.clientX < window.innerWidth - 300) {
        if (showMeshName) {
          console.log("Show Tag");
          showTag(e);
        } else {
          tag.style.display = "none";
        }
      } else {
        tag.style.display = "none";
        if (activeItem) {
          activeItem.material.color.set(activeItem.userData.color);
          activeItem.material.emissiveIntensity = 0;
        }
      }
      if (itemType == "listItem") {
        if (INTERSECTED) {
          INTERSECTED.material.color.set(INTERSECTED.userData.color);
          setEmissive(INTERSECTED, false);
        }
        INTERSECTED = assemblyRoot.getObjectByName(e.target.children[2].innerText);
        if (INTERSECTED != undefined) {
          INTERSECTED.material.color.set(focusColor);
          setEmissive(INTERSECTED, true, focusColor);
        }
      }
    }
    function onMouseUp(e) {
      cancelPress();
      let id = e.target.id;
      if (id === "canvas" && e.ctrlKey) {
        mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
        raycaster.setFromCamera(mouse, camera);
        let intersects = raycaster.intersectObjects(assemblyRoot.children, true);
        if (intersects.length > 0) {
          transform.attach(assembly);
          transformOn = true;
        } else {
          transform.detach();
          transformOn = false;
        }
        if (activeItem) {
          activeItem = null;
        }
        if (activeListItem) {
          activeListItem.classList.remove("selected");
          activeListItem = null;
        }
        param.style.display = "none";
      } else if (id === "gcanvas") {
        let rect = gizmo.canvas.getBoundingClientRect();
        let mouse = new THREE.Vector2();
        mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
        let raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, gizmo.camera);
        let intersects = raycaster.intersectObjects(gizmo.box.children, true);
        if (intersects.length > 0) {
          let intersect = intersects[0].object;
          gizmo.moveToView(intersect.name, camera, controls);
        }
      } else if (id === "closePopup") {
        popup.hide();
        let lst = activeListItem.parentNode;
        lst.children[1].style.display = "none";
        lst.children[2].style.display = "flex";
        lst.children[2].classList.add("selected");
        showMeshName = true;
        listMini.hideInput(miniInput);
      }
    }
    function onDoubleClick(e) {
      console.log(e.target.getAttribute("itemType"));
      if (e.target.getAttribute("itemType") == "listItem") {
        activeListItem.classList.remove("selected");
        let lst = e.target;
        activeNameInput = lst.children[1];
        activeNameInput.style.display = "flex";
        activeNameInput.focus();
        lst.children[2].style.display = "none";
        activeNameInput.value = lst.children[2].innerText;
        activeNameInput.addEventListener("blur", onListFocusOut);
      } else if (e.target.getAttribute("itemType") == "listMiniItem") {
        miniInput = e.target.children[1];
        miniInput.style.display = "flex";
        miniInput.value = e.target.children[2].innerText;
        meshName.current.innerHTML = "Mesh - " + miniInput.value;
        e.target.children[2].style.display = "none";
        activeItem = scene.getObjectByName(miniInput.value);
        setTimeout(() => {
          miniInput.focus();
          miniInput.addEventListener("blur", onFocusOut);
        }, 50);
      } else if (e.target.id === "canvas") {
        mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
        raycaster.setFromCamera(mouse, camera);
        let intersects = raycaster.intersectObjects(assemblyRoot.children, true);
        if (intersects.length > 0) {
          let firstIntersect = intersects[0].object;
          tag.style.display = "none";
          param.style.display = "block";
          if (orientation == "portrait") {
            setActiveMiniItem(firstIntersect.name);
            selectedType = "mesh";
            meshName.current.innerHTML = "Mesh - " + firstIntersect.name;
            listMini.selectListItem(firstIntersect.name);
            activeItem = scene.getObjectByName(firstIntersect.name);
          } else {
            setActiveItem(firstIntersect.name);
          }
          menuAssembly.style.filter = "grayscale(100%)";
          menuAssembly.setAttribute("enable", false);
          assemblyPage.current.style.bottom = "-60vh";
        } else {
          if (activeItem) {
            activeItem.material.color.set(activeItem.userData.color);
            setEmissive(activeItem, false);
            activeItem = null;
          }
          if (activeListItem) {
            activeListItem.classList.remove("selected");
            activeListItem = null;
            param.style.display = "none";
          } else {
            param.style.display = "none";
          }
          transform.detach();
          transformOn = false;

          meshPage.current.style.bottom = "-60vh";
          assemblyPage.current.style.bottom = "-60vh";

          menuMesh.style.filter = "grayscale(100%)";
          menuMesh.setAttribute("enable", false);

          menuAssembly.style.filter = "grayscale(100%)";
          menuAssembly.setAttribute("enable", false);

          listMini.selectListItem("");
        }
      }
    }
    function showTag(e) {
      mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      let intersects = raycaster.intersectObjects(assemblyRoot.children, true);
      if (intersects.length > 0) {
        let firstIntersect = intersects[0].object;
        if (INTERSECTED !== firstIntersect) {
          if (INTERSECTED) {
            INTERSECTED.material.color.set(INTERSECTED.userData.color);
            setEmissive(INTERSECTED, false);
            if (activeItem) {
              activeItem.material.color.set(selectedColor);
              setEmissive(activeItem, false);
            }
          }
          INTERSECTED = firstIntersect;
          if (activeItem == INTERSECTED) {
            INTERSECTED.material.color.set(selectedColor);
            setEmissive(INTERSECTED, true, selectedColor);
          } else {
            INTERSECTED.material.color.set(focusColor);
            setEmissive(INTERSECTED, true, focusColor);
          }
          if (activeItem) {
            activeItem.material.color.set(selectedColor);
            setEmissive(activeItem, true, selectedColor);
          }
        }
        tag.style.display = "block";
        tag.style.left = e.clientX + 10 + "px";
        tag.style.top = e.clientY + 10 + "px";

        console.log(firstIntersect.name);

        tag.innerHTML = firstIntersect.name || "(no name)";
      } else {
        tag.style.display = "none";
        if (INTERSECTED) {
          INTERSECTED.material.color.set(INTERSECTED.userData.color);
          setEmissive(INTERSECTED, false);
        }
        INTERSECTED = null;
        if (activeItem) {
          activeItem.material.color.set(selectedColor);
          setEmissive(activeItem, true, selectedColor);
        }
      }
    }
    function onFocusOut(e) {
      miniInput.removeEventListener("blur", onFocusOut);
      // setNewMiniLabel(miniInput.value);
      listMini.updateLabel(miniInput, miniInput.value);
    }
    function onKeyDown(e) {
      console.log(e.key);
      if (e.key == "Enter") {
        if (e.target.parentNode.parentNode.id == "list") {
          setNewLabel(e.target.value);
        } else if (e.target.parentNode.getAttribute("itemType") == "listMiniItem") {
          miniInput = e.target;
          setNewMiniLabel(e.target.value);
        }
      } else if (e.altKey && e.key.toLowerCase() === "s") {
        if (activeItem) {
          let focus = { p: camera.position.clone(), t: controls.target.clone() };
          activeItem.userData.focus = focus;
        }
      } else if (e.key === "F11") {
        e.preventDefault();
        isFullscreen.current = !isFullscreen.current;
        if (isFullscreen.current) {
          switchFullScreen();
        } else {
          switchNormScreen();
        }
      } else if (e.key.toLowerCase() === "r" && e.altKey) {
        e.preventDefault();
        transform.setMode("rotate");
        translate.src = getAsset("drag.svg", "images");
        rotate.src = getAsset("rotateOn.svg", "images");
      } else if (e.key.toLowerCase() === "t" && e.altKey) {
        e.preventDefault();
        transform.setMode("translate");
        translate.src = getAsset("dragOn.svg", "images");
        rotate.src = getAsset("rotate.svg", "images");
      } else if (e.key === "F1") {
        e.preventDefault();
        showHelp();
      } else if (e.key.toLowerCase() === "s" && e.ctrlKey) {
        e.preventDefault();
        saveProj();
      } else if (e.key.toLowerCase() === "l" && e.ctrlKey) {
        e.preventDefault();
        fileInput.click();
      } else if (e.key === "Tab") {
        e.preventDefault();
        camera.position.copy(reset.position);
        controls.target.copy(reset.target);
        view.rotation.y = 0;
      } else if (e.key.toLowerCase() === "p" && e.ctrlKey) {
        e.preventDefault();
        takeSnapshot();
      } else if (e.key == "Home") {
        showMeshName = false;
        if (!isFullscreen.current) {
          popup.show("You haven't saved the project.\nDo you want to quit Model View?", [
            { id: "quitAppYes", caption: "Yes" },
            { id: "quitAppNo", caption: "No" },
          ]);
        }
      }
    }
    function setNewMiniLabel(lbl) {
      showMeshName = false;
      let str = lbl.trim().replace(/\s+/g, "_");
      let firstChar = str.charAt(0);
      let exists = items.some((mesh) => mesh !== activeItem && mesh.name === str);
      if (str.length == 0) {
        showNameError("You have to enter any valid name");
      } else if (exists) {
        showNameError("Name already exists");
      } else if (!isNaN(firstChar)) {
        showNameError("The name cannot start with a number");
      } else {
        // let itm = scene.getObjectByName(meshes[i].name)
        let item = miniInput.parentNode;
        let oldName = item.children[2].innerText;
        // elem.style.display = "none";
        // elem.value = str;
        // item.children[2].innerText = str;
        // item.children[2].style.display = "flex";
        let mesh = scene.getObjectByName(oldName);
        mesh.name = str;
        // items.sort((a, b) => a.name.localeCompare(b.name));
        // // filteredList = items;
        // filteredList = items.filter((item) => item.name.toLowerCase().includes(lbl.toLowerCase()));
        // listMini.setItems(filteredList, assemblyRoot, hidden, scene);

        listMini.updateLabel(miniInput, str);
        // filteredList = items.filter((item) => item.name.toLowerCase().includes(searchInput.value.toLowerCase()));
        // listMini.setItems(filteredList, assemblyRoot, hidden, scene);

        // activeItem.name = str;
        // let lst = activeListItem.parentNode;
        // lst.id = activeNameInput.value;
        // activeNameInput.removeEventListener("blur", onListFocusOut);
        // activeNameInput = null;

        // lst.children[2].innerText = str;
        // lst.children[1].style.display = "none";
        // lst.children[2].style.display = "flex";

        // items.sort((a, b) => a.name.localeCompare(b.name));
        // filteredList = items.filter((item) => item.name.toLowerCase().includes(searchInput.value.toLowerCase()));
        // listMini.setItems(filteredList, assemblyRoot, hidden, scene);

        // reloadList();
        // lst = document.querySelector("#list #" + str);
        // activeListItem = lst.children[2];
        // activeListItem.classList.add("selected");
        // return;
      }
      // activeNameInput.removeEventListener("blur", onListFocusOut);
      // activeNameInput = null;
    }
    function onKeyUp(e) {
      if (e.key == "Delete" && activeItem) {
        if (activeItem) {
          if (panelLeft.current.contains(e.target) || panelRight.current.contains(e.target)) {
            return;
          } else {
            delMeshName = activeItem.name;
            confirmMeshDelete();
          }
        }
      }
    }
    function addSNS(row, cols, id, label, value, min, max, step, jump, fixed, unit, width) {
      let sns = new SlidingNumericStepper(false, id, label, value, min, max, step, jump, fixed, unit, width);
      if (cols != 0) {
        let col = addDiv(row, "", cols == 3 ? "col3" : "col2");
        sns.appendTo(col);
      } else {
        sns.appendTo(row);
      }
      sns.addEventListener("VALUE_CHANGE", onSNSChange);
      return sns;
    }
    function loadGLBModelByArrayBuffer(arrayBuffer) {
      let loader = new GLTFLoader();
      loader.parse(
        arrayBuffer,
        "",
        (gltf) => {
          loadGLTF(gltf);
        },
        function (xhr) {
          let p = Math.round((xhr.loaded / xhr.total) * 100);
          setLoaded(p);
        },
        (error) => {
          console.error("Error loading GLB", error);
        },
      );
    }
    function loadGLBModel(url) {
      setShowPreloader(true);
      let loader = new GLTFLoader();
      loader.load(
        url,
        (gltf) => {
          loadGLTF(gltf);
        },
        function (xhr) {
          // console.log(xhr.loaded);
        },
        function (error) {
          console.error("Error loading GLB", error);
        },
      );
    }
    function loadSTLModelByArrayBuffer(arrayBuffer) {
      setShowPreloader(true);
      let loader = new STLLoader();

      let geometry = loader.parse(arrayBuffer); // parse synchronously returns geometry
      let parts = separateDisconnectedParts(geometry);
      let index = 0;

      parts.forEach((g) => {
        let color = new THREE.Color(Math.random(), Math.random(), Math.random());
        let mat = new THREE.MeshStandardMaterial({ color: color });
        let mesh = new THREE.Mesh(g, mat);
        mesh.name = "mesh_" + index;
        setupMesh(mesh);
        index++;
      });
      resetPlane();
      filteredList = [];
      items.sort((a, b) => a.name.localeCompare(b.name));
      listMini.setItems(items, assemblyRoot, hidden, scene);
      filteredList = [...items];
      totalItems = filteredList.length;
      itemCount.innerHTML = "Total Meshes: " + totalItems + " / " + totalItems;

      let box = new THREE.Box3().setFromObject(assemblyRoot);
      let center = new THREE.Vector3();
      box.getCenter(center);
      assemblyRoot.position.sub(center);

      setTimeout(() => {
        setShowPreloader(false);
      }, 1000);

      reloadList();
    }
    function loadSTLModel(url) {
      setShowPreloader(true);
      let loader = new STLLoader();
      loader.load(url, function (geometry) {
        let parts = separateDisconnectedParts(geometry);
        let index = 0;
        parts.forEach((g) => {
          let color = new THREE.Color(Math.random(), Math.random(), Math.random());
          let mat = new THREE.MeshStandardMaterial({ color: color });
          let mesh = new THREE.Mesh(g, mat);
          mesh.name = "mesh_" + index;
          setupMesh(mesh);
          index++;
        });
        console.log("i m in loadSTLModel");
        resetPlane();
        filteredList = [];
        items.sort((a, b) => a.name.localeCompare(b.name));
        listMini.setItems(items, assemblyRoot, hidden, scene);
        filteredList = [...items];
        totalItems = filteredList.length;
        itemCount.innerHTML = "Total Meshes: " + totalItems + " / " + totalItems;
        let box = new THREE.Box3().setFromObject(assemblyRoot);
        let center = new THREE.Vector3();
        box.getCenter(center);
        assemblyRoot.position.sub(center);
        setTimeout(() => {
          setShowPreloader(false);
        }, 1000);
        reloadList();
      });
    }
    function loadGLTF(gltf) {
      let obj = gltf.scene;
      obj.traverse((node) => {
        if (node.isMesh) {
          setupMesh(node);
        }
      });
      resetPlane();
      filteredList = [];
      items.sort((a, b) => a.name.localeCompare(b.name));
      listMini.setItems(items, assemblyRoot, hidden, scene);
      filteredList = [...items];
      totalItems = filteredList.length;
      itemCount.innerHTML = "Total Meshes: " + totalItems + " / " + totalItems;
      let box = new THREE.Box3().setFromObject(assemblyRoot);
      let center = new THREE.Vector3();
      box.getCenter(center);
      assemblyRoot.position.sub(center);
      setTimeout(() => {
        setShowPreloader(false);
        if (orientation == "portrait") {
          panelLeft.current.style.display = "none";
        }
      }, 1000);
      if (data) {
        setTimeout(() => {
          snsFOV.value = camera.fov = data.fov;
          camera.updateProjectionMatrix();
          snsAmbient.value = data.a;
          ambient.intensity = data.a / 100;
          snsDirect.value = data.d;
          lightTop.intensity = lightBottom.intensity = lightLeft.intensity = lightRight.intensity = lightFront.intensity = lightBack.intensity = data.d / 100;
          // snsBY.value = plane.position.y = data.g;
          plane.visible = chkShadow.children[0].checked = data.shadow;
          chkHDRI.children[0].checked = data.hdri == 1 ? true : false;
          scene.environment = data.hdri == 1 ? hdri : null;
          chkSkybox.children[0].checked = data.skybox == 1 ? true : false;
          scene.background = data.skybox == 1 ? hdri : null;
          chkSpin.children[0].checked = spin = data.spin == 1 ? true : false;
          assembly.position.set(data.ax, data.ay, data.az);
          assembly.rotation.set(data.arx, data.ary, data.arz);
          snsAX.value = data.ax;
          snsAY.value = data.ay;
          snsAZ.value = data.az;
          snsARX.value = data.arx;
          snsARY.value = data.ary;
          snsARZ.value = data.arz;
          camera.position.set(data.cameraPosition.x, data.cameraPosition.y, data.cameraPosition.z);
          controls.target.set(data.controlTarget.x, data.controlTarget.y, data.controlTarget.z);
        }, 1500);
      }
      if (data && data.meshes) {
        let meshes = data.meshes;
        console.log(meshes);
        return;
        // let lstItems = list.children;
        // allvisible = false;
        // allLock = true;
        // for(let i=0; i<meshes.length; i++){
        //   let itm = scene.getObjectByName(meshes[i].name)
        //   itm.userData.visible = meshes[i].visible;
        //   itm.userData.lock = meshes[i].lock;
        //   itm.material.color.set(meshes[i].color);
        //   itm.userData.color = meshes[i].color;

        //   itm.userData.x1 = meshes[i].x1;
        //   itm.userData.y1 = meshes[i].y1;
        //   itm.userData.z1 = meshes[i].z1;

        //   itm.userData.x2 = meshes[i].x2;
        //   itm.userData.y2 = meshes[i].y2;
        //   itm.userData.z2 = meshes[i].z2;

        //   itm.userData.rx1 = meshes[i].rx1;
        //   itm.userData.ry1 = meshes[i].ry1;
        //   itm.userData.rz1 = meshes[i].rz1;

        //   itm.userData.rx2 = meshes[i].rx2;
        //   itm.userData.ry2 = meshes[i].ry2;
        //   itm.userData.rz2 = meshes[i].rz2;

        //   if(meshes[i].tile){
        //     itm.userData.tile = snsM.value = meshes[i].tile;
        //   }
        //   if(meshes[i].texture){
        //     console.log("meshes:", meshes[i].texture)
        //     applyTexture(itm, meshes[i].texture);
        //   }
        //   if(meshes[i].metalness){
        //     itm.material.matelness = itm.userData.metalness = meshes[i].metalness;
        //     snsM.value = meshes[i].metalness * 100;
        //   }
        //   if(meshes[i].roughness){
        //     itm.material.roughness = itm.userData.roughness = meshes[i].roughness;
        //     snsR.value = meshes[i].roughness * 100;
        //   }
        //   if(!meshes[i].visible){
        //     hidden.add(itm);
        //   }else{
        //     allvisible = true;
        //   }
        //   if(!meshes[i].lock){
        //     allLock = false
        //   }
        // }

        // unlock.src = allLock?"/images/lock.svg":"/images/unlock.svg";
        // toggleView.src = allvisible?"/images/eyeOpen.svg":"/images/eyeClose.svg";
      }
      reloadList();
    }
    function resetPlane() {
      let sbox = new THREE.Box3().setFromObject(assemblyRoot);
      let size = new THREE.Vector3();
      sbox.getSize(size);
      snsBY.value = plane.position.y = (-size.y / 2 - 0.1).toFixed(2);
      paramAssembly.style.display = "flex";
    }
    function setupMesh(node) {
      centerMesh(node);
      var applyMat = false;
      if (node.geometry.attributes.uv) {
      } else {
        generateBoxUVs(node.geometry);
        applyMat = true;
      }
      let clonedMesh = node.clone(true);
      let firstChar = node.name.charAt(0);
      if (!isNaN(firstChar)) {
        clonedMesh.name = "_" + node.name;
      }
      if (Array.isArray(node.material)) {
        clonedMesh.material = node.material.map((mat) => mat.clone());
      } else if (node.material) {
        clonedMesh.material = node.material.clone();
      }
      clonedMesh.name = getUniqueName(clonedMesh.name, assemblyRoot);
      assemblyRoot.add(clonedMesh);
      clonedMesh.userData.lock = false;
      clonedMesh.userData.visible = true;
      let tmpColor = 0xcccccc;
      let mat = new THREE.MeshPhysicalMaterial({
        color: 0xcccccc,
        metalness: 0.8,
        roughness: 0.5,
        side: THREE.DoubleSide,
        reflectivity: 0.6,
        clearcoat: 0.1,
        transparent: true,
        alphaTest: 0.5,
        clearcoatRoughness: 0,
        ior: 1.5,
      });
      if (applyMat) {
        clonedMesh.material = mat;
      }
      clonedMesh.castShadow = true;
      clonedMesh.userData.tile = 1;
      clonedMesh.material.color.set(clonedMesh.userData.color);
      clonedMesh.userData.metalness = clonedMesh.material.metalness;
      clonedMesh.userData.roughness = clonedMesh.material.roughness;
      clonedMesh.material.emissiveIntensity = clonedMesh.userData.emissiveIntensity = 0;
      clonedMesh.userData.emissive = tmpColor;
      clonedMesh.material.emissive.set(tmpColor);
      clonedMesh.userData.color = tmpColor;
      clonedMesh.userData.explode = false;
      let x = Math.ceil(clonedMesh.position.x * 10) / 10;
      let y = Math.ceil(clonedMesh.position.y * 10) / 10;
      let z = Math.ceil(clonedMesh.position.z * 10) / 10;
      clonedMesh.position.x = clonedMesh.userData.x1 = clonedMesh.userData.x2 = x;
      clonedMesh.position.y = clonedMesh.userData.y1 = clonedMesh.userData.y2 = y;
      clonedMesh.position.z = clonedMesh.userData.z1 = clonedMesh.userData.z2 = z;
      clonedMesh.userData.rx1 = clonedMesh.userData.rx2 = clonedMesh.rotation.x;
      clonedMesh.userData.ry1 = clonedMesh.userData.ry2 = clonedMesh.rotation.y;
      clonedMesh.userData.rz1 = clonedMesh.userData.rz2 = clonedMesh.rotation.z;
      items.push(clonedMesh);
    }
    function generateBoxUVs(geometry) {
      let pos = geometry.attributes.position;
      let uvArray = [];
      for (let i = 0; i < pos.count; i++) {
        let x = pos.getX(i);
        let y = pos.getY(i);
        let z = pos.getZ(i);
        uvArray.push((x + 1) / 2, (z + 1) / 2);
      }
      geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvArray, 2));
    }
    function centerMesh(mesh) {
      mesh.geometry.computeBoundingBox();
      let bbox = mesh.geometry.boundingBox;
      let center = bbox.getCenter(new THREE.Vector3());
      mesh.geometry.translate(-center.x, -center.y, -center.z);
      mesh.position.add(center);
    }
    function separateDisconnectedParts(geometry) {
      let nonIndexed = geometry.toNonIndexed();
      let pos = nonIndexed.attributes.position.array;
      let vertexCount = pos.length / 3;

      let triangleCount = vertexCount / 3;

      let threshold = 1e-5;

      let vertexMap = new Map();

      for (let i = 0; i < vertexCount; i++) {
        let key = `${pos[i * 3].toFixed(5)},${pos[i * 3 + 1].toFixed(5)},${pos[i * 3 + 2].toFixed(5)}`;
        if (!vertexMap.has(key)) vertexMap.set(key, []);
        vertexMap.get(key).push(i);
      }

      let adj = Array(triangleCount)
        .fill()
        .map(() => []);
      for (let i = 0; i < triangleCount; i++) {
        let verts = [i * 3, i * 3 + 1, i * 3 + 2];
        let neighbors = new Set();
        verts.forEach((vIdx) => {
          let key = `${pos[vIdx * 3].toFixed(5)},${pos[vIdx * 3 + 1].toFixed(5)},${pos[vIdx * 3 + 2].toFixed(5)}`;
          vertexMap.get(key).forEach((otherVIdx) => {
            let tri = Math.floor(otherVIdx / 3);
            if (tri !== i) neighbors.add(tri);
          });
        });
        adj[i] = Array.from(neighbors);
      }

      let used = new Array(triangleCount).fill(false);
      let groups = [];

      function dfs(start, group) {
        let stack = [start];
        used[start] = true;

        while (stack.length > 0) {
          let curr = stack.pop();
          group.push(curr);
          adj[curr].forEach((n) => {
            if (!used[n]) {
              used[n] = true;
              stack.push(n);
            }
          });
        }
      }

      for (let i = 0; i < triangleCount; i++) {
        if (!used[i]) {
          let group = [];
          dfs(i, group);
          groups.push(group);
        }
      }

      let geometries = groups.map((group) => {
        let g = new THREE.BufferGeometry();
        let positions = [];

        group.forEach((triIdx) => {
          let base = triIdx * 9;
          positions.push(pos[triIdx * 9], pos[triIdx * 9 + 1], pos[triIdx * 9 + 2], pos[triIdx * 9 + 3], pos[triIdx * 9 + 4], pos[triIdx * 9 + 5], pos[triIdx * 9 + 6], pos[triIdx * 9 + 7], pos[triIdx * 9 + 8]);
        });

        g.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
        g.computeVertexNormals();
        return g;
      });

      return geometries;
    }
    function reloadList() {
      list.innerHTML = "";
      let allvisible = false;
      let alllock = true;
      for (let i = 0; i < filteredList.length; i++) {
        let item = addDiv(list, filteredList[i].name, "item");
        item.setAttribute("itemType", "listItem");
        if (i > 0) {
          item.style.borderTop = "1px solid #CCCCCC";
        }
        let icon = addImage(item, "", "iconCube.svg", "iconStyle");
        icon.style.pointerEvents = "none";
        icon.style.marginLeft = "2px";
        icon.style.width = "20px";
        icon.style.height = "18px";
        let inputName = addInput(item, "inputName" + i, "", "inputName");
        let label = addDiv(item, "label", "itemLabel");
        label.innerHTML = filteredList[i].name;
        let mesh = scene.getObjectByName(filteredList[i].name);
        if (mesh.userData.visible) {
          allvisible = true;
        }
        if (!mesh.userData.lock) {
          alllock = false;
        }
        let eyeIcon = mesh.userData.visible ? "eyeOpen.svg" : "eyeClose.svg";
        let eye = addImage(item, "eye", eyeIcon, "listHeaderIcon");
        eye.setAttribute("itemType", "eye");
        let lockIcon = mesh.userData.lock ? "lock.svg" : "unlock.svg";
        let unlock = addImage(item, "lock", lockIcon, "listHeaderIcon");
        unlock.setAttribute("itemType", "lock");
        let del = addImage(item, "del", "delete.svg", "listHeaderIcon");
        unlock.style.marginLeft = "10px";
        unlock.style.marginRight = "5px";
      }
      let eye = allvisible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
      toggleView.src = eye;
      let lock = alllock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
      unlock.src = lock;
    }
    function onSearchInput(e) {
      filteredList = items.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()));
      itemCount.innerHTML = "Total Meshes: " + filteredList.length + " / " + totalItems;
      reloadList();
    }
    function updateMeshMatrixHeight() {
      let totalHeight = window.innerHeight;
      let listBoxRect = listBox.getBoundingClientRect();
      meshMatrixHeight = 300;
      document.documentElement.style.setProperty("--meshMatrixHeight", meshMatrixHeight + "px");
      meshMatrixBox.style.maxHeight = meshMatrixHeight + "px";
    }
    function onSwitchChange(e) {
      let id = e.detail.id;
      let state = e.detail.state;
      console.log(id);
      console.log(state);
      msg.current.innerHTML = id;
      if (id === "switchParamExplode" || id === "switchExplode_m") {
        activeItem.userData.explode = state;
        setActiveItem(activeItem.name);
      } else if (id === "switchExplode") {
        for (let i = 0; i < items.length; i++) {
          console.log(i);
          explode(state, items[i]);
        }
      }
    }
    function setActiveMiniItem(itm, prop = true) {
      if (activeItem) {
        activeItem.material.color.set(activeItem.userData.color);
        setEmissive(activeItem, false);
      }
      activeItem = scene.getObjectByName(itm);
      setEmissive(activeItem, true, selectedColor);
      transform.detach();
      transformOn = false;
      if (!activeItem.userData.lock) {
        if (activeItem.userData.explode) {
          transform.attach(activeItem);
        } else {
          transform.detach();
        }
        transformOn = true;
        menuMesh.style.filter = "none";
        menuMesh.setAttribute("enable", true);
        if (prop) {
          let s = window.getComputedStyle(panelLeft.current);
          if (s.display == "block") {
          } else {
            showPage(meshPage.current, "0px");
          }
        }
      }
    }
    function setActiveItem(itm) {
      selectedType = "mesh";
      console.log(itm);
      if (activeListItem) {
        activeListItem.classList.remove("selected");
      }
      activeListItem = list.querySelector("#" + itm).children[2];
      activeListItem.classList.add("selected");
      smoothScrollToParent(list, activeListItem, 500);
      if (activeItem) {
        activeItem.material.color.set(activeItem.userData.color);
        setEmissive(activeItem, false);
      }
      activeItem = scene.getObjectByName(itm);
      transform.detach();
      transformOn = false;
      if (!activeItem.userData.lock) {
        transform.attach(activeItem);
        transformOn = true;
      }

      snsT.value = activeItem.userData.tile;
      snsM.value = activeItem.userData.metalness * 100;
      snsR.value = activeItem.userData.roughness * 100;
      if (activeItem.userData.focus) {
        let targetPos = activeItem.userData.focus.p;
        let targetLook = activeItem.userData.focus.t;
        new TWEEN.Tween(camera.position).to({ x: targetPos.x, y: targetPos.y, z: targetPos.z }, 1500).easing(TWEEN.Easing.Quadratic.InOut).start();
        new TWEEN.Tween(controls.target)
          .to({ x: targetLook.x, y: targetLook.y, z: targetLook.z }, 1500)
          .easing(TWEEN.Easing.Quadratic.InOut)
          .onUpdate(() => {
            controls.update();
          })
          .start();
      }
      let acolor = "#" + activeItem.userData.color.toString(16).padStart(6, "0").toUpperCase();
      colorPicker.style.background = acolor;
      colorInput.value = acolor;
      switchParamExplode.setState(activeItem.userData.explode);

      if (activeItem.userData.explode) {
        // snsX.value = Math.round(activeItem.userData.x2);
        // snsY.value = Math.round(activeItem.userData.y2);
        // snsZ.value = Math.round(activeItem.userData.z2);

        snsX.value = activeItem.userData.x2;
        snsY.value = activeItem.userData.y2;
        snsZ.value = activeItem.userData.z2;

        snsRX.value = activeItem.userData.rx2;
        snsRY.value = activeItem.userData.ry2;
        snsRZ.value = activeItem.userData.rz2;

        x_m.setValue(activeItem.userData.x2);
        y_m.setValue(activeItem.userData.y2);
        z_m.setValue(activeItem.userData.z2);

        rx_m.setValue(activeItem.userData.rx2);
        ry_m.setValue(activeItem.userData.ry2);
        rz_m.setValue(activeItem.userData.rz2);

        activeItem.position.x = activeItem.userData.x2;
        activeItem.position.y = activeItem.userData.y2;
        activeItem.position.z = activeItem.userData.z2;

        activeItem.rotation.x = activeItem.userData.rx2 * deg2Rad;
        activeItem.rotation.y = activeItem.userData.ry2 * deg2Rad;
        activeItem.rotation.z = activeItem.userData.rz2 * deg2Rad;
      } else {
        snsX.value = activeItem.userData.x1;
        snsY.value = activeItem.userData.y1;
        snsZ.value = activeItem.userData.z1;

        snsRX.value = activeItem.userData.rx1 * rad2Deg;
        snsRY.value = activeItem.userData.ry1 * rad2Deg;
        snsRZ.value = activeItem.userData.rz1 * rad2Deg;

        x_m.setValue(activeItem.userData.x1);
        y_m.setValue(activeItem.userData.y1);
        z_m.setValue(activeItem.userData.z1);

        rx_m.setValue(activeItem.userData.rx1);
        ry_m.setValue(activeItem.userData.ry1);
        rz_m.setValue(activeItem.userData.rz1);

        activeItem.position.x = activeItem.userData.x1;
        activeItem.position.y = activeItem.userData.y1;
        activeItem.position.z = activeItem.userData.z1;

        activeItem.rotation.x = activeItem.userData.rx1 * deg2Rad;
        activeItem.rotation.y = activeItem.userData.ry1 * deg2Rad;
        activeItem.rotation.z = activeItem.userData.rz1 * deg2Rad;
      }
      activeItem.material.color.set(selectedColor);
      setEmissive(activeItem, true, selectedColor);
      setDisable(activeItem.userData.lock);
      param.style.display = "block";
      // param.style.display = "block";
      unlockExplodeParam();
      resize();
    }
    function unlockExplodeParam() {
      if (activeItem.userData.explode) {
        explodeParam.style.filter = "none";
        explodeParam.style.opacity = 1;
        explodeParam.style.pointerEvents = "all";

        explodeParam_m.style.filter = "none";
        explodeParam_m.style.opacity = 1;
        explodeParam_m.style.pointerEvents = "all";

        // x_m.setValue(activeItem.userData.x2);
        // y_m.setValue(activeItem.userData.y2);
        // z_m.setValue(activeItem.userData.z2);

        // rx_m.setValue(activeItem.userData.rx2 * rad2Deg);
        // ry_m.setValue(activeItem.userData.ry2 * rad2Deg);
        // rz_m.setValue(activeItem.userData.rz2 * rad2Deg);

        transform.attach(activeItem);
      } else {
        explodeParam.style.filter = "grayscale(100%)";
        explodeParam.style.opacity = 0.5;
        explodeParam.style.pointerEvents = "none";

        explodeParam_m.style.filter = "grayscale(100%)";
        explodeParam_m.style.opacity = 0.5;
        explodeParam_m.style.pointerEvents = "none";

        // x_m.setValue(activeItem.userData.x1);
        // y_m.setValue(activeItem.userData.y1);
        // z_m.setValue(activeItem.userData.z1);

        // rx_m.setValue(activeItem.userData.rx1 * rad2Deg);
        // ry_m.setValue(activeItem.userData.ry1 * rad2Deg);
        // rz_m.setValue(activeItem.userData.rz1);

        transform.detach();
      }
    }
    function explode(explode, mesh) {
      let target = {
        px: explode ? mesh.userData.x1 : mesh.userData.x2,
        py: explode ? mesh.userData.y1 : mesh.userData.y2,
        pz: explode ? mesh.userData.z1 : mesh.userData.z2,
        rx: explode ? mesh.userData.rx1 * deg2Rad : mesh.userData.rx2 * deg2Rad,
        ry: explode ? mesh.userData.ry1 * deg2Rad : mesh.userData.ry2 * deg2Rad,
        rz: explode ? mesh.userData.rz1 * deg2Rad : mesh.userData.rz2 * deg2Rad,
      };
      let tween = new TWEEN.Tween(target)
        .to(
          {
            px: explode ? mesh.userData.x2 : mesh.userData.x1,
            py: explode ? mesh.userData.y2 : mesh.userData.y1,
            pz: explode ? mesh.userData.z2 : mesh.userData.z1,
            rx: explode ? mesh.userData.rx2 * deg2Rad : mesh.userData.rx1 * deg2Rad,
            ry: explode ? mesh.userData.ry2 * deg2Rad : mesh.userData.ry1 * deg2Rad,
            rz: explode ? mesh.userData.rz2 * deg2Rad : mesh.userData.rz1 * deg2Rad,
          },
          tweenDuration,
        )
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          mesh.position.set(target.px, target.py, target.pz);
          mesh.rotation.set(target.rx, target.ry, target.rz);
        })
        .start();
    }
    function setEmissive(mesh, state, color) {
      if (!state) {
        mesh.material.emissive.set(0x000000);
        mesh.material.emissiveIntensity = 0;
      } else {
        mesh.material.emissive.set(color);
        mesh.material.emissiveIntensity = eIntensity;
      }
    }
    function setDisable(state) {
      if (state) {
        meshMatrixBox.style.filter = "grayscale(100%)";
        meshMatrixBox.style.pointerEvent = "none";
        meshMatrixBox.style.opacity = 0.5;
        paramLock.style.display = "block";
      } else {
        meshMatrixBox.style.filter = "none";
        meshMatrixBox.style.pointerEvent = "all";
        meshMatrixBox.style.opacity = 1;
        paramLock.style.display = "none";
      }
    }
    function onSNSChange(e) {
      let id = e.detail.id;
      let value = e.detail.value;
      if (id == "snsX") {
        activeItem.position.x = value;
        if (activeItem.userData.explode) {
          activeItem.userData.x2 = value;
        } else {
          activeItem.userData.x1 = value;
        }
      } else if (id == "snsY") {
        activeItem.position.y = value;
        if (activeItem.userData.explode) {
          activeItem.userData.y2 = value;
        } else {
          activeItem.userData.y1 = value;
        }
      } else if (id == "snsZ") {
        activeItem.position.z = value;
        if (activeItem.userData.explode) {
          activeItem.userData.z2 = value;
        } else {
          activeItem.userData.z1 = value;
        }
      } else if (id == "snsRX") {
        activeItem.rotation.x = value * deg2Rad;
        if (activeItem.userData.explode) {
          activeItem.userData.rx2 = value;
        } else {
          activeItem.userData.rx1 = value;
        }
      } else if (id == "snsRY") {
        activeItem.rotation.y = value * deg2Rad;
        if (activeItem.userData.explode) {
          activeItem.userData.ry2 = value;
        } else {
          activeItem.userData.ry1 = value;
        }
      } else if (id == "snsRZ") {
        activeItem.rotation.z = value * deg2Rad;
        if (activeItem.userData.explode) {
          activeItem.userData.rz2 = value;
        } else {
          activeItem.userData.rz1 = value;
        }
      } else if (id == "snsM") {
        activeItem.material.metalness = activeItem.userData.metalness = value / 100;
      } else if (id == "snsR") {
        activeItem.material.roughness = activeItem.userData.roughness = value / 100;
      } else if (id == "snsT") {
        setTile(value);
      } else if (id == "snsBY") {
        plane.position.y = value;
      } else if (id == "snsFOV") {
        camera.fov = value;
        camera.updateProjectionMatrix();
      } else if (id == "snsAmbient") {
        ambient.intensity = value / 100;
      } else if (id == "snsDirect") {
        lightTop.intensity = lightBottom.intensity = lightLeft.intensity = lightRight.intensity = lightFront.intensity = lightBack.intensity = value / 100;
      } else if (id == "snsAX") {
        assembly.position.x = value;
      } else if (id == "snsAY") {
        assembly.position.y = value;
      } else if (id == "snsAZ") {
        assembly.position.z = value;
      } else if (id == "snsARX") {
        assembly.rotation.x = value * deg2Rad;
      } else if (id == "snsARY") {
        assembly.rotation.y = value * deg2Rad;
      } else if (id == "snsARZ") {
        assembly.rotation.z = value * deg2Rad;
      }
    }
    function setTile(value) {
      let tile = value / 1000;
      activeItem.userData.tile = value;
      let texture = activeItem.material.map;
      if (texture) {
        texture.repeat.set(tile, tile);
        texture.needsUpdate = true;
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      }
    }
    function clearView() {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        item.geometry.dispose();
        item.material.dispose();
      }
      assemblyRoot.remove(...assemblyRoot.children);
      items = [];
      renderer.dispose();
    }
    animate();
    resize();

    return () => {
      if (canvas.current && renderer.domElement) {
        renderer.domElement.id = "canvas";
        if (canvas.current.contains(renderer.domElement)) {
          canvas.current.removeChild(renderer.domElement);
        }
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        item.geometry.dispose();
        item.material.dispose();
      }
      renderer.dispose();
      cancelAnimationFrame(animateRef.current);
      if (renderer.domElement && renderer.domElement.parentNode) {
        renderer.domElement.parentNode.removeChild(renderer.domElement);
      }
      scene.clear();
      window.removeEventListener("resize", resize);
      window.removeEventListener("touchstart", startPress);
      window.removeEventListener("touchend", cancelPress);
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("dblclick", onDoubleClick);
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);

      setTimeout(() => {
        header.appendChild(logo);
      }, 3000);
    };
  }, []);

  return (
    <div ref={app} id="app" style={{ width: "100vw", height: "100vh", position: "relative" }}>
      <div ref={canvas} style={{ width: "100vw", height: "100%" }}></div>
      <div ref={gizmoDiv} className="gizmoDiv" style={{ zIndex: 3000 }} />
      <div ref={toolsDiv} className="toolsDiv" />
      <div ref={panelLeft} className="panelLeft" />
      <div ref={panelRight} className="panelRight" />
      <div ref={userPage} className="userPage">
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "10vh" }}>
          <img id="userImage" src={getAsset("hassan.jpg", "images")} className="mvProfilePhoto" />
          {/* <div style={{display:"flex", height:"10vh",fontSize:"1.5vh", alignItems:"center", fontWeight:700}}>Hassan Azzam<br/>Wesleyan University<br/>Batch(2021) - Final Year</div> */}
          <div style={{ display: "flex", height: "10vh", fontSize: "1.5vh", alignItems: "center", fontWeight: 700 }}>
            {/* {user.name} */}
            Muhammad Uzair
            <br />
            {/* user.school */}
            FAST NUCES
            <br />
            Batch: 2022
          </div>
        </div>
        <div style={{ fontSize: "1.5vh", padding: "10px", height: "10.5vh", overflowY: "auto", width: "100%", display: "flex", textAlign: "justify" }}>This 3D assembly model integrates all components of my final year engineering project into a cohesive design, ensuring accurate fitment and alignment. It allowed me to visualize the complete structure, check part compatibility, and verify feasibility before manufacturing, demonstrating practical application of my CAD skills.</div>
        {/* <div style={{ fontSize: "1.5vh", padding: "10px", height: "10.5vh", overflowY: "auto", width: "100%", display: "flex", textAlign: "justify" }}>{project.details}</div> */}
        <div className="pageTitle">User</div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={filePage} className="filePage">
        <div style={{ marginTop: "7vh", width: "100%", height: "30%", display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
          <div id="btnLoadAssembly" className="fileButton">
            Load Assembly
          </div>
          <div id="btnDeleteAssembly" className="fileButton">
            Delete Assembly
          </div>
          <div id="btnSaveProject" className="fileButton">
            Save Project
          </div>
          <div id="btnSaveMeshView" className="fileButton">
            Save Mesh View
          </div>
          <div id="btnReset" className="fileButton">
            Reset Camera
          </div>
          <div id="btnSnap" className="fileButton">
            Viewport Snap
          </div>
        </div>
        <div className="pageTitle">File</div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={viewportPage} className="viewportPage">
        <div className="pageTitle">Viewport</div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={listPage} className="listPage">
        <div className="pageTitle">List</div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={assemblyPage} className="assemblyPage">
        <div className="pageTitle">Assembly</div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={meshPage} className="meshPage">
        <div ref={meshName} className="pageTitle">
          Mesh
        </div>
        <img id="close" src={getAsset("close.svg", "images")} className="close" />
      </div>
      <div ref={menu} className="menu" />
      <MVPreloader show={showPreloader} />
      <div ref={msg} className="msg" style={{ display: "none" }}></div>
    </div>
  );
}
